/*
 * The texts of the notes extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		note: {
			toggle: 'Übersicht ein-/ausklappen',
			add: 'Seite hinzufügen',
			rename: 'Titel bearbeiten',
			delete: 'Seite löschen',
			up: 'Nach oben schieben',
			down: 'Nach unten schieben',
		},
	},
	pages: {
		note_book: {
			table_of_content: 'Übersicht',
			add_page: 'Seite hinzufügen',
			new_page: 'Neue Seite',
			draft_hint: 'wird beim Schreiben angelegt',
			placeholder: 'Notiz eingeben',
			untitled: 'Ohne Titel',
		},
	},
	confirms: {
		delete_note_page: {
			title: 'Seite loeschen',
			text: 'Soll die Seite "{title}" wirklich geloescht werden?',
		},
	},
};
